import list from './MassSendCircle'

export default list
